import { render, staticRenderFns } from "./u-icon.vue?vue&type=template&id=172979f2&scoped=true&"
import script from "./u-icon.vue?vue&type=script&lang=js&"
export * from "./u-icon.vue?vue&type=script&lang=js&"
import style0 from "./u-icon.vue?vue&type=style&index=0&id=172979f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172979f2",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-icon/u-icon.vue"
export default component.exports